// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3HNL4","validationTips":"StatementDescriptor_validationTips__HR6If"};